// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CaseTcg() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>トレカNFTのPoC</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>トレーディングカード</span>
            <span>ブロックチェーン事業開発</span>
          </div>
          <h1 className="cd-title">
            日本のトレーディングカードを、NFTで米国のコレクターに届けるPoC
          </h1>
          <p className="cd-client">トレーディングカード販売会社</p>
          <div className="cd-img is-cover">
            <span className="cover-en">TRADING CARD NFT</span>
            <span className="cover-ja">トレーディングカード × NFT</span>
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                米国のコレクターが、日本のトレカのNFTに対価を払うかを確かめたい。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>
                市場調査・NFTの仕組み・OpenSeaでの販売・X運用をPoCとして実施。
              </p>
            </div>
            <div>
              <span>成果</span>
              <p>
                本格展開の判断に向けて、需要を小さく検証する体制を構築（検証中）。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              日本のトレーディングカードをNFTにし、NFTの保有者が実物のカードと引き換えられる形で、米国のコレクターへ販売するPoC（概念実証）です。本格的な投資の前に、米国市場の需要を小さな規模で確かめることを目的にしています。
            </p>
          </section>
          <section className="cd-sec">
            <h2>お客様の課題</h2>
            <ul className="cd-list">
              <li>
                米国のコレクターが、日本のトレカのNFTに実際に対価を払うかが分からなかった
              </li>
              <li>
                本格展開の前に、運用・市場・法務のリスクを小さく洗い出したかった
              </li>
              <li>米国のコレクター層に届く集客の方法が確立していなかった</li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSの対応</h2>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">市場調査</p>
                <h3 className="cd-ptitle">米国市場の調査と販売設計</h3>
                <p>
                  米国のトレカ市場や競合を調査し、カードの価格やレアリティの見せ方など、販売の設計に反映しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">NFTの仕組み</p>
                <h3 className="cd-ptitle">NFTの発行と実物カードへの引き換え</h3>
                <p>
                  NFTの発行・OpenSeaへの出品と、NFTから実物のカードを請求できる引き換えの流れを設計しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">マーケティング</p>
                <h3 className="cd-ptitle">米国コレクターへの集客</h3>
                <p>
                  米国向けのXアカウントの運用やコミュニティでの発信を行い、販売に向けた集客を進めています。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>今後の展望</h2>
            <p>
              フォロワー数・売れ行き率・米国の購入者の比率などの指標をもとに、本格展開・改善・撤退を判断できるよう、検証を進めています。
            </p>
          </section>
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/premience">
              <div className="case-img">
                <img src="/assets/images/case-premience.jpg" alt="" />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
              </h3>
              <div className="case-tags">
                <span>旅行・観光</span>
                <span>ブランディング・Web制作</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
